module.exports = __webpack_public_path__ + "static/media/login.f4ff9c5e.png";